import type { Ref } from '@vue/composition-api';
import { ref } from '@vue/composition-api';
import { defineStore } from 'pinia';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import { DsrService } from '../../api/dsr/service/dsr.service';

export const useParticipantsStore = defineStore('participants', () => {
  const recipients: Ref<Recipient[]> = ref([]);
  const user: Ref<User> = ref(undefined);
  const universalLink = ref('');

  const loadRecipients = async () => {
    try {
      recipients.value = await DsrService.loadRecipients();
    } catch {
      recipients.value = [];
    }
  };

  const loadUser = async () => {
    try {
      user.value = await DsrService.loadUser();
    } catch {
      user.value = undefined;
    }
  };

  const loadUniversalLink = async () => {
    try {
      universalLink.value = await DsrService.loadUniversalLink();
    } catch {
      universalLink.value = '';
    }
  };

  const reset = () => {
    recipients.value = [];
    user.value = undefined;
    universalLink.value = '';
  };

  return { loadRecipients, loadUser, reset, recipients, user, loadUniversalLink, universalLink };
});
